// Loại dự toán ngân sách
export default {
  BeginNMLNS: 1, // 'Dự toán thu đầu năm theo MLNS',
  AdditionalMLNS: 2, // 'Dự toán thu bổ sung theo MLNS',
  ReadjustMLNS: 3, // 'Điều chỉnh dự toán thu theo MLNS',
  BeginNDKT: 4, // 'Dự toán thu đầu năm theo NDKT',
  AdditionalNDKT: 5, // 'Dự toán thu bổ sung theo NDKT',
  ReadjustNDKT: 6, // 'Điều chỉnh dự toán thu theo NDKT',
};
